import BathAndBodySection from './BathAndBodySection';
import Swiper from '~/ui/components/common/Swiper/Swiper';
import FragranceSection from './FragranceSection';
import BathSection from './BathSection';
import { feelWellImages, fragranceImages } from '../../../../assets/mocks/swiperImages';
import { useTranslation } from 'next-i18next';

const FeelWellSection = () => {
  const { t } = useTranslation('', { keyPrefix: '$pages.$home.$feelWell' });
  const { t: tLink } = useTranslation('', { keyPrefix: '$local.$homePageLinks.$feelWell' });
  const translatedFeelWellImages = feelWellImages.map(image => ({
    ...image,
    title: t(`${image.url_key}Title`),
    alt: t(`${image.url_key}Alt`),
    url_key: tLink(image.url_key),
  }));
  const translatedFragranceImages = fragranceImages.map(image => ({
    ...image,
    title: t(`${image.url_key}Title`),
    alt: t(`${image.url_key}Alt`),
    url_key: tLink(image.url_key),
  }));
  return (
    <>
      <div className="home-bath">
        <BathAndBodySection />
        <Swiper slides={translatedFeelWellImages} />
      </div>
      <div className="home-fragrance">
        <FragranceSection />
        <Swiper slides={translatedFragranceImages} />
      </div>
      <BathSection />
    </>
  );
};

export default FeelWellSection;
